export default __webpack_public_path__ + "static/media/producto-09.87a4ec67.jpg";